<template>
  <el-container class="basic-layout">
    <el-header class="header-layout">
      <base-header ref="baseHeader" />
    </el-header>
    <el-main class="content-layout">
      <router-view></router-view>
    </el-main>
    <public-footer />
  </el-container>
</template>

<script>
import BaseHeader from "./Header.vue";
import PublicFooter from "@/components/Layouts/PublicFooter.vue";
export default {
  name: "BasicLayout",
  components: {
    BaseHeader,
    PublicFooter,
  },
  props: {},
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  updated() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.basic-layout {
  background: transparent;
  min-width: 1200px;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  padding-top: 88px; // 为固定头部在桌面端预留空间

  .header-layout {
    position: fixed;
    z-index: 1000;
    width: 100%;
    max-width: 100%;
    min-width: 1042px;
    height: 88px !important;
    padding: 0;
    margin: 0;
    top: 0;
    left: 0;
    right: 0;
    background: url("~@/assets/images/head-banner.jpg") no-repeat;
    background-size: 100% 100%;
    box-shadow: 0 0 12px 0px rgba(0, 0, 0, 0.5);
  }

  .content-layout {
    width: 100%;
    //min-width: 1042px;
    background: url("~@/assets/images/body-bg.jpg") no-repeat;
    background-size: 100% 536px;
    overflow-x: hidden;
    padding-top: 0; // 由容器 .basic-layout 负责预留
  }
}

// 暂时禁用全局平滑滚动，改为手动控制
// :global(html) {
//   scroll-behavior: smooth;
// }

// 为所有锚点元素添加通用的scroll-margin-top
:global(.section) {
  scroll-margin-top: 120px; // PC端默认偏移

  @media (max-width: 1024px) {
    scroll-margin-top: 100px;
  }

  @media (max-width: 768px) {
    scroll-margin-top: 90px;
  }

  @media (max-width: 480px) {
    scroll-margin-top: 80px;
  }
}

// 移动端响应式样式 - 使用更宽松的断点
@media (max-width: 1024px) {
  .basic-layout {
    min-width: auto !important;
    width: 100% !important;
    max-width: 100% !important;
    overflow-x: hidden !important;
    padding-top: 70px !important; // 移动端按头部高度预留

    .header-layout {
      min-width: auto !important;
      width: 100% !important;
      max-width: 100% !important;
      height: 70px !important;
      margin: 0 !important;
      padding: 0 !important;
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      right: 0 !important;
      z-index: 1000 !important;
    }

    .content-layout {
      min-width: auto !important;
      width: 100% !important;
      max-width: 100% !important;
      margin: 0 !important;
      padding: 0 !important;
    }
  }
}

// 平板端响应式样式
@media (max-width: 1042px) and (min-width: 1025px) {
  .basic-layout {
    min-width: auto !important;
    width: 100% !important;
    max-width: 100% !important;

    .header-layout {
      min-width: auto !important;
      width: 100% !important;
      max-width: 100% !important;
    }

    .content-layout {
      min-width: auto !important;
      width: 100% !important;
      max-width: 100% !important;
    }
  }
}

// 小屏幕设备优化
@media (max-width: 768px) {
  .basic-layout {
    .header-layout {
      height: 60px !important;
    }
    padding-top: 60px !important;
  }
}

// 超小屏幕设备优化
@media (max-width: 480px) {
  .basic-layout {
    .header-layout {
      height: 50px !important;
    }
    padding-top: 50px !important;
  }
}

// 确保在所有设备上都没有水平滚动
@media (max-width: 1200px) {
  .basic-layout {
    overflow-x: hidden !important;

    .header-layout,
    .content-layout {
      overflow-x: hidden !important;
    }
  }
}

// 移动端内容区域优化
@media (max-width: 1024px) {
  .basic-layout {
    .content-layout {
      // 确保内容区域在移动端正常显示
      min-height: calc(100vh - 70px) !important;

      // 移动端背景图片优化
      background-attachment: scroll !important;

      // 确保子组件能正常显示
      > * {
        width: 100% !important;
        max-width: 100% !important;
        min-width: auto !important;
        overflow-x: hidden !important;
        // 子视图顶部避免被遮挡 - 使用scroll-margin-top替代
        // scroll-margin-top: 80px;
      }
    }
  }
}

// 超小屏幕特殊处理
@media (max-width: 375px) {
  .basic-layout {
    .content-layout {
      min-height: calc(100vh - 50px) !important;
    }
  }
}
</style>
